import './style/main.css'
import axios from 'axios'
let keydownEnabled = true
export function disableKeydown() {
    keydownEnabled = false
}

export function enableKeydown() {
    keydownEnabled = true
}

export function isKeydownEnabled() {
    return keydownEnabled
}

export function openModal() {
    const modal = document.getElementById('contact-modal')
    if (!modal) return

    modal.style.display = 'flex'
    disableKeydown()

    // const closeBtn = document.getElementById('close-modal')

    // // Close when clicking the close button
    // if (closeBtn) {
    //     closeBtn.onclick = () => {
    //         modal.style.display = 'none'
    //         currentIndex = 0
    //         enableKeydown()
    //     }
    // }

    // // Close when clicking outside the modal content
    // window.onclick = (event) => {
    //     if (event.target === modal) {
    //         currentIndex = 0
    //         renderComponent(currentIndex)
    //         modal.style.display = 'none'
    //         enableKeydown()
    //     }
    // }

    // Close when form is submitted
    
}
openModal()
let currentIndex = 0; // change this to 0
let selectedValues = [];

const carTypes = [
  {
    name: 'Sedan',
    description: 'A comfortable car for city driving.',
    image: './images/sedan.png'
  },
  {
    name: 'Hatchback',
    description: 'A spacious car for family trips.',
    image: './images/hatchback.png'
  },
  {
    name: 'Coupe',
    description: 'A powerful vehicle for heavy loads.',
    image: './images/coupe.png'
  },
  {
    name: 'Minivan',
    description: 'A comfortable car for city driving.',
    image: './images/minivan.png'
  },
  {
    name: 'SUV & Crossover',
    description: 'A spacious car for family trips.',
    image: './images/suv.png'
  },
  {
    name: 'Truck',
    description: 'A powerful vehicle for heavy loads.',
    image: './images/truck.png'
  }
];

const budgetOptions = [
  {
    name: 'Under $350',
  },
  {
    name: '$350- $500',
  },
  {
    name: '$500- $650',
  },
  {
    name: '$650- $800',
  },
  {
    name: 'Over $800',
  },
];

const trade = [
  {
    name: 'Yes',
  },
  {
    name: 'No',
  },
  {
    name: 'Unsure',
  },
];
const rating = [
  {
    name: 'Great! (650-900)',
  },
  {
    name: 'Fair! (500-650)',
  },
  {
    name: 'Poor! (Below 500)',
  },
  {
    name: 'No Credit / Unsure',
  },
];
const employee = [
  {
    name: 'Employed',
  },
  {
    name: 'Self-Employed',
  },
  {
    name: 'Student',
  },
  {
    name: 'Retired/Pension',
  },
  {
    name: 'Other',
  },
];
const resident = [
  {
    name: 'Yes',
  },
  {
    name: 'No',
  },]

  const Driving = [
    {
      name: 'Yes',
    },
    {
      name: 'No',
    },]
const income = [
  {
    name: '0-3 Months',
  },
  {
    name: '3-6 Months',
  },
  {
    name: 'More than 6 Months',
  },]


  function handleBack() {
    console.log("here");
    if (currentIndex > 0) {
      currentIndex--;
      renderComponent(currentIndex);
    }
  }

const backButton = `<br/>
<button id="back-button" class="md:px-20 px-8 bg-gradient-to-r from-blue-400 to-blue-600 text-white py-2 rounded-lg hover:from-blue-500 hover:to-blue-700 transition">Back</button>
`
const step1 = carTypes.map((carType, index) => `
  <div class="car-type-card cursor-pointer flex flex-col border rounded p-2 hover:shadow-lg transition " id="car-type-${index}" onclick="selectValue('${carType.name}')">
    <img src="${carType.image}" alt="${carType.name}" class="w-full lg:h-42 h-18 object-contain rounded">
    <h3 class="lg:text-lg items-end text-sm font-bold">${carType.name}</h3>
    
  </div>
`).join('');

const step2 = budgetOptions.map((option, index) => `
  <div 
    class="budget-option-card cursor-pointer border border-gray-300 rounded-2xl p-4 hover:shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-center bg-white"
    id="budget-option-${index}" 
    onclick="selectValue('${option.name}')"
  >
    <h3 class="lg:text-xl text-sm font-semibold text-gray-800">${option.name}</h3>
  </div>
`).join('');

const step3 = trade.map((option, index) => `
  <div 
    class="budget-option-card cursor-pointer border border-gray-300 rounded-2xl p-4 hover:shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-center bg-white"
    id="budget-option-${index}" 
    onclick="selectValue('${option.name}')"
  >
    <h3 class="lg:text-xl text-sm font-semibold text-gray-800">${option.name}</h3>
  </div>
`).join('');
const step4 = rating.map((option, index) => `
  <div 
    class="budget-option-card cursor-pointer border border-gray-300 rounded-2xl p-4 hover:shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-center bg-white"
    id="budget-option-${index}" 
    onclick="selectValue('${option.name}')"
  >
    <h3 class="lg:text-xl text-sm font-semibold text-gray-800">${option.name}</h3>
  </div>
`).join('');

const step5 = employee.map((option, index) => `
  <div 
    class="budget-option-card cursor-pointer border border-gray-300 rounded-2xl p-4 hover:shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-center bg-white"
    id="budget-option-${index}" 
    onclick="selectValue('${option.name}')"
  >
    <h3 class="lg:text-xl text-sm font-semibold text-gray-800">${option.name}</h3>
  </div>
`).join('');

const step6 = income.map((option, index) => `
  <div 
    class="budget-option-card cursor-pointer border border-gray-300 rounded-2xl p-4 hover:shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-center bg-white"
    id="budget-option-${index}" 
    onclick="selectValue('${option.name}')"
  >
    <h3 class="lg:text-xl text-sm font-semibold text-gray-800">${option.name}</h3>
  </div>
`).join('');
const step7 = `
  <div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">What is your income before taxes & deductions?</h2>
    
    <div class="mt-4">
      <label for="income-slider" class="block text-sm font-medium text-gray-700 mb-2">Select your income:</label>
      <input 
        type="range" 
        id="income-slider" 
        min="10000" 
        max="200000" 
        step="1000" 
        value="50000" 
        class="md:px-20 px-8"
        oninput="updateIncomeSlider(event)"
      >
      <p id="income-value" class="text-lg font-semibold text-gray-800 mt-2">$50,000</p>
      <p id="annual-income-warning" class="text-red-500 text-sm hidden">Please select a valid income.</p>
    </div>
    <button id="continue-button" class="md:px-20 px-8 bg-gradient-to-r from-blue-400 to-blue-600 text-white py-2 rounded-lg hover:from-blue-500 hover:to-blue-700 transition">Continue</button>
    ${backButton}
  </div>
`;

const step8 = `
  <div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">Where do you work?</h2>
    
    <div class="mt-4">
      <input 
        type="text" 
        id="company-name" 
        placeholder="Enter Your Company Name" 
        class="border border-gray-300 rounded-lg p-2 md:px-20 px-8 outline-none focus:ring-2 focus:ring-blue-500"
        oninput="updateCompanyName(event)"
      >
      <p id="company-name-warning" class="text-red-500 text-sm hidden">Please enter your company name.</p>
    </div>
    <div class="mt-4">
      <input 
        type="text" 
        id="job-title" 
        placeholder="Enter Your Job Title" 
        class="border border-gray-300 rounded-lg p-2 md:px-20 px-8 outline-none focus:ring-2 focus:ring-blue-500"
        oninput="updateJobTitle(event)"
      >
      <p id="job-title-warning" class="text-red-500 text-sm hidden">Please enter your job title.</p>
    </div>
    <p>We won’t contact your employer—this just helps us get you the best rates.</p>
    <button id="continue-button" class="md:px-20 px-8 bg-gradient-to-r from-blue-400 to-blue-600 text-white py-2 rounded-lg hover:from-blue-500 hover:to-blue-700 transition">Continue</button>
    ${backButton}
  </div>
`;

const step9 = `
  <div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">Where are you looking for a vehicle?</h2>
    <div class="mt-4 w-full" style="position:relative;">
      <input 
        type="text" 
        id="annual-income" 
        placeholder="Start typing your home address" 
        class="border w-full border-gray-300 rounded-lg p-2 outline-none focus:ring-2 focus:ring-blue-500"
        onchange="updateIncomeValue(event)"
        autocomplete="off"
      >
      <p id="annual-income-warning" class="text-red-500 text-sm hidden">Please enter your home address.</p>
    </div>
    <p>This helps us find the best car options available in your area.</p>
    <button id="continue-button" class="md:px-20 px-8 bg-gradient-to-r from-blue-400 to-blue-600 text-white py-2 rounded-lg hover:from-blue-500 hover:to-blue-700 transition">Continue</button>
    ${backButton}
  </div>
`;
const step10 = resident.map((option, index) => `
  <div 
    class="budget-option-card cursor-pointer border border-gray-300 rounded-2xl p-4 hover:shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-center bg-white"
    id="budget-option-${index}" 
    onclick="selectValue('${option.name}')"
  >
    <h3 class="lg:text-xl text-sm font-semibold text-gray-800">${option.name}</h3>
  </div>
`).join('');

const step11 = Driving.map((option, index) => `
  <div 
    class="budget-option-card cursor-pointer border border-gray-300 rounded-2xl p-4 hover:shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-center bg-white"
    id="budget-option-${index}" 
    onclick="selectValue('${option.name}')"
  >
    <h3 class="lg:text-xl text-sm font-semibold text-gray-800">${option.name}</h3>
  </div>
`).join('');

const step12 = `
  <div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">Just checking whether you're old enough for financing?</h2>
    <p>Enter your date of birth</p>
    <div class="date-picker" tabindex="0">
      <input 
        id="dob" 
        type="text" 
        placeholder="DD/MM/YYYY" 
        inputmode="numeric" 
        maxlength="10"
        class="border border-gray-300 rounded-lg p-2 md:px-20 px-8 outline-none focus:ring-2 focus:ring-blue-500"
        autocomplete="bday"
        oninput="updateDob(event)"
        required
      >
    </div>
    <br/>
    <p id="dob-warning" class="text-red-500 text-sm hidden">Date of birth is required in dd/mm/yyyy format.</p>
    <button id="continue-button" class="md:px-20 px-8 bg-gradient-to-r from-blue-400 to-blue-600 text-white py-2 rounded-lg hover:from-blue-500 hover:to-blue-700 transition">Continue</button>
    ${backButton}
  </div>
`;
const step13 = `
  <div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">🎉 Great, you're approved!</h2>
    <h3 class="md:text-2xl text-lg font-semibold text-gray-700">We'll provide you with the best offer for your van's financing.</h3>
    <p>Who should we send the offer to?</p>
    
    <div class="mt-4">
      <input 
        type="text" 
        id="first-name" 
        placeholder="Enter your First name" 
        class="border border-gray-300 rounded-lg p-2 md:px-20 px-8 outline-none focus:ring-2 focus:ring-blue-500"
        oninput="updateFirstName(event)"
      >
      <p id="first-name-warning" class="text-red-500 text-sm hidden">First name is required.</p>
    </div>
    <div class="mt-4">
      <input 
        type="text" 
        id="last-name" 
        placeholder="Enter your Last name" 
        class="border border-gray-300 rounded-lg p-2 md:px-20 px-8 outline-none focus:ring-2 focus:ring-blue-500"
        oninput="updateLastName(event)"
      >
      <p id="last-name-warning" class="text-red-500 text-sm hidden">Last name is required.</p>
    </div>
    <button id="continue-button" class="md:px-20 px-8 bg-gradient-to-r from-blue-400 to-blue-600 text-white py-2 rounded-lg hover:from-blue-500 hover:to-blue-700 transition">Continue</button>
    ${backButton}
  </div>
`;
const step14 = `
  <div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">🤩 All set for your new vehicle </h2>
    <p>Who should we send the offer to?</p>
    <div class="mt-4">
      <label for="email" class="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
      <input 
        type="email" 
        id="email" 
        placeholder="Enter your email" 
        class="border border-gray-300 rounded-lg p-3 md:px-20 px-8 outline-none focus:ring-2 focus:ring-blue-500"
        oninput="updateEmail(event)"
      >
      <div id="email-warning" class="text-red-500 text-sm mt-1 hidden">Email is required.</div>
    </div>

    <div class="mt-4">
      <label for="phone" class="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
      <div class="">
        <span id="country-code" class="border border-gray-300 rounded-l-lg p-3 bg-gray-100 text-gray-700">+1</span>
        <input 
          type="tel" 
          id="phone" 
          placeholder="Enter your phone number" 
          class="border border-gray-300 rounded-r-lg p-3 md:px-20 px-8 outline-none focus:ring-2 focus:ring-blue-500"
          oninput="updatePhone(event)"
        >
      </div>
      <div id="phone-warning" class="text-red-500 text-sm mt-1 hidden">Phone number is required.</div>
    </div>

    <p> By clicking “Submit”,you agree that ${window.location.hostname=="form.cutmydebt.ca"?"Cutmydebt.ca ":"Mainland Motors "}may check your credit to help match you with the best car financing options.</p>

    <button id="send-otp-button" class="md:px-20 px-8 bg-gradient-to-r from-blue-500 to-blue-700 text-white py-3 rounded-lg hover:from-blue-600 hover:to-blue-800 transition">
    Submit
    </button>
    ${backButton}
  </div>
`;

const step15 = `
  <div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">Verify OTP</h2>
    
    <div class="mt-4">
      <label for="otp" class="block text-sm font-medium text-gray-700 mb-2">Enter the OTP</label>
      <div id="otp-input" class="flex space-x-2 justify-center">
        <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="1" class="otp-box border border-gray-300 rounded-lg p-3 w-12 text-center outline-none focus:ring-2 focus:ring-blue-500" oninput="handleOtpInput(event, 0)" onkeydown="handleOtpBackspace(event, 0)">
        <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="1" class="otp-box border border-gray-300 rounded-lg p-3 w-12 text-center outline-none focus:ring-2 focus:ring-blue-500" oninput="handleOtpInput(event, 1)" onkeydown="handleOtpBackspace(event, 1)">
        <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="1" class="otp-box border border-gray-300 rounded-lg p-3 w-12 text-center outline-none focus:ring-2 focus:ring-blue-500" oninput="handleOtpInput(event, 2)" onkeydown="handleOtpBackspace(event, 2)">
        <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="1" class="otp-box border border-gray-300 rounded-lg p-3 w-12 text-center outline-none focus:ring-2 focus:ring-blue-500" oninput="handleOtpInput(event, 3)" onkeydown="handleOtpBackspace(event, 3)">
      </div>
      <p id="otp-warning" class="text-red-500 text-sm hidden mt-2">Please enter the OTP.</p>
    </div>
    <button id="verify-otp-button" class="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-3 rounded-lg hover:from-blue-600 hover:to-blue-800 transition">
      Verify OTP
    </button>
    ${backButton}
  </div>
`;

window.updateOtp = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].otp = value;
  console.log('Updated OTP:', value);
};
window.updateIncomeSlider = function(event) {
  const value = event.target.value; // Get the current slider value
  const incomeValueElement = document.getElementById('income-value'); // Element to display the value

  // Update the displayed income value
  incomeValueElement.textContent = `$${Number(value).toLocaleString()}`;

  // Update the selectedValues array
  selectedValues[currentIndex] = value;
  console.log('Updated Income:', value);
};
// Functions to handle input changes
window.updateCompanyName = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].companyName = value; // Update company name in selectedValues
  console.log('Updated Company Name:', value);
};

window.updateJobTitle = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].jobTitle = value; // Update job title in selectedValues
  console.log('Updated Job Title:', value);
};

window.updateEmail = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].email = value;
  console.log('Updated Email:', value);
};

window.updatePhone = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].phone = value;
  console.log('Updated Phone:', value);
};

// Function to handle input changes
window.updateIncomeValue = function(event) {
  const value = event.target.value;
  const incomeWarning = document.getElementById('annual-income-warning');

  // Check if the input is not a valid number
  if (!value) {
    console.log
    incomeWarning.classList.remove('hidden'); // Show warning
  } else {
    incomeWarning.classList.add('hidden'); // Hide warning
  }

  selectedValues[currentIndex] = value; // Update the selectedValues array
  console.log('Updated Income:', value);
};

window.updateDob = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].dob = value;
  console.log('Updated Date of Birth:', value);
};

window.updateFirstName = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].first = value;
  console.log('Updated first Name:', value);
};
window.updateLastName = function(event) {
  const value = event.target.value;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].last = value;
  console.log('Updated last Name:', value);
};

window.updateCountryCode = function(event) {
  const countryCode = event.target.value;
  document.getElementById('country-code').textContent = countryCode;
  selectedValues[currentIndex] = selectedValues[currentIndex] || {};
  selectedValues[currentIndex].countryCode = countryCode;
  console.log('Updated Country Code:', countryCode);
};

window.handleOtpInput = function(event, index) {
  const inputBoxes = document.querySelectorAll('.otp-box');
  let value = event.target.value.replace(/[^0-9]/g, ''); // Only allow numbers
  event.target.value = value;

  // Move to next box if a digit is entered
  if (value.length === 1 && index < inputBoxes.length - 1) {
    inputBoxes[index + 1].focus();
    inputBoxes[index + 1].select();
  }
};

window.handleOtpBackspace = function(event, index) {
  const inputBoxes = document.querySelectorAll('.otp-box');
  if ((event.key === "Backspace" || event.key === "Delete") && event.target.value === "" && index > 0) {
    inputBoxes[index - 1].focus();
    inputBoxes[index - 1].value = "";
    event.preventDefault();
  }
};
function validateStep(index) {
  const renderer = document.getElementById('render-component');
  let isValid = true;

  switch (index) {
    

    case 7: // Step 8: Company Name and Job Title
      const companyInput = renderer.querySelector('#company-name');
      const jobInput = renderer.querySelector('#job-title');
      const companyWarning = renderer.querySelector('#company-name-warning');
      const jobWarning = renderer.querySelector('#job-title-warning');
      if (!companyInput.value.trim()) {
        companyWarning.classList.remove('hidden'); // Show warning
        isValid = false;
      } else {
        companyWarning.classList.add('hidden'); // Hide warning
      }
      if (!jobInput.value.trim()) {
        jobWarning.classList.remove('hidden'); // Show warning
        isValid = false;
      } else {
        jobWarning.classList.add('hidden'); // Hide warning
      }
      break;

    case 8: // Step 9: Home Address
      const addressInput = renderer.querySelector('#annual-income');
      const addressWarning = renderer.querySelector('#annual-income-warning');
      if (!addressInput.value.trim()) {
        addressWarning.classList.remove('hidden'); // Show warning
        isValid = false;
      } else {
        addressWarning.classList.add('hidden'); // Hide warning
      }
      break;

    case 11: // Step 12: Date of Birth
      const dobInput = renderer.querySelector('#dob');
      const dobWarning = renderer.querySelector('#dob-warning');

      // Debugging logs to ensure elements are found
      console.log('DOB Input:', dobInput);
      console.log('DOB Warning:', dobWarning);

      if (!dobInput) {
        console.error('DOB Input not found in the DOM.');
        isValid = false;
        break;
      }

      if (!dobInput.value.trim()) {
        if (dobWarning) {
          dobWarning.classList.remove('hidden'); // Show warning
        }
        isValid = false;
      } else {
        if (dobWarning) {
          dobWarning.classList.add('hidden'); // Hide warning
        }
      }
      break;

    case 12: // Step 13: Full Name
      const firstNameInput = renderer.querySelector('#first-name');
      const lastNameInput = renderer.querySelector('#last-name');
      const firstNameWarning = renderer.querySelector('#first-name-warning');
      const lastNameWarning = renderer.querySelector('#last-name-warning');
      if (!firstNameInput || !firstNameInput.value.trim() || !lastNameInput || !lastNameInput.value.trim()) {
        if (firstNameWarning) {
          firstNameWarning.classList.remove('hidden'); // Show warning
        }
        if (lastNameWarning) {
          lastNameWarning.classList.remove('hidden'); // Show warning
        }
        
        isValid = false;
      } else {
        if (firstNameWarning) {
          firstNameWarning.classList.add('hidden'); // Hide warning
        }
        if (lastNameWarning) {
          firstNameWarning.classList.add('hidden'); // Hide warning
        }
      }
      break;

    case 13: // Step 14: Email and Phone
      const emailInput = renderer.querySelector('#email');
      const phoneInput = renderer.querySelector('#phone');
      const emailWarning = renderer.querySelector('#email-warning');
      const phoneWarning = renderer.querySelector('#phone-warning');

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
      if (!emailInput || !emailRegex.test(emailInput.value.trim())) {
        if (emailWarning) {
          emailWarning.classList.remove('hidden'); // Show warning
        }
        isValid = false;
      } else {
        if (emailWarning) {
          emailWarning.classList.add('hidden'); // Hide warning
        }
      }

      // Phone validation
      const phoneRegex = /^[0-9]{10}$/; // Basic phone regex (10 digits)
      if (!phoneInput || !phoneRegex.test(phoneInput.value.trim())) {
        if (phoneWarning) {
          phoneWarning.classList.remove('hidden'); // Show warning
        }
        isValid = false;
      } else {
        if (phoneWarning) {
          phoneWarning.classList.add('hidden'); // Hide warning
        }
      }
      break;

    // case 14: // Step 15: OTP
    //   const otpInput = renderer.querySelector('#otp');
    //   const otpWarning = renderer.querySelector('#otp-warning');
    //   if (!otpInput.value.trim()) {
    //     otpWarning.classList.remove('hidden'); // Show warning
    //     isValid = false;
    //   } else {
    //     otpWarning.classList.add('hidden'); // Hide warning
    //   }
    //   break;

    default:
      break;
  }

  return isValid;
}

const formData = [
  `<div class="car-selection text-center space-y-2 flex flex-col items-center gap-4">
    <p>🔥 Check your eligibility in just 60 seconds</p>
    <p>All cars are at all-time lowest prices for our lot clearance sale!</p>
    
    <h2 class="text-xl md:text-3xl font-bold">What type of car are you looking to buy?</h2>
    <div class="car-types overflow-y-auto grid grid-cols-2 lg:grid-cols-3 gap-4 md:px-16">
      ${step1}
    </div>
    
  </div>`,
  `<div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">What's your monthly payment expectation?</h2>
    <div class="car-types grid grid-cols-1  gap-6 md:px-20 px-8 ">
      ${step2}
    </div>
    ${backButton}
    </div>`,
  `<div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">Do you have a Trade-in?</h2>
    <div class="car-types grid grid-cols-1  gap-6 md:px-20 px-8 ">
      ${step3}
    </div>
    ${backButton}
    </div>`,
  `<div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">What is your estimated credit rating?</h2>
    <div class="car-types grid grid-cols-1  gap-6 md:px-20 px-8 ">
      ${step4}
    </div>
    <p>We need this information to confirm your eligibility</p>
    ${backButton}
    </div>`,
  `<div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">What is your employment status?</h2>
    <div class="car-types grid grid-cols-1  gap-6 md:px-20 px-8 ">
      ${step5}
    </div>
    <p>We ask to ensure you can afford the loan</p>
    ${backButton}
    </div>`,
  step7,
  `<div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">How long at this income level?</h2>
    <div class="car-types grid grid-cols-1  gap-6 md:px-20 px-8 ">
      ${step6}
    </div>
    <p>This helps us find the right loan options</p>
    ${backButton}
    </div>`,
  step8,
  step9,
  `<div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">Are you a canadian citizen or permanent resident?</h2>
    <div class="car-types grid grid-cols-1  gap-6 md:px-20 px-8 ">
      ${step10}
    </div>
    ${backButton}
    </div>`,
  `<div class="car-selection text-center space-y-6 my-4">
    <h2 class="md:text-3xl text-xl font-bold text-gray-800">Do you have a valid canadian driver's licence?</h2>
    <div class="car-types grid grid-cols-1  gap-6 md:px-20 px-8 ">
      ${step11}
    </div>
    ${backButton}
    </div>`,
  step12,
  step13,
  step14,
  step15,
  // `<div class="thank-you-message text-center space-y-2">
  //   <img src="./images/thanks.jpeg" alt="Thank You" class="w-full mx-auto mb-4">
  //   <p>We'll contact you via <bold>${selectedValues[13]?.email}</bold> within the next 24 hours.</p>
  //   </div>`
];

function getStep16(email) {
  return `<div class="thank-you-message text-center space-y-2">
    <img src="./images/thanks.jpeg" alt="Thank You" class="md:w-1/2 mx-auto mb-4">
    <p>We'll contact you via <b>${email}</b> within the next 24 hours.</p>
  </div>`;
}
function renderComponent(index) {
  const renderer = document.getElementById('render-component');
  if (!renderer) return;
  if (index === formData.length) {
    const email = selectedValues[13]?.email || '';
    renderer.innerHTML = getStep16(email);
    return;
  }

  renderer.innerHTML = `
    <div id="progress-bar-container" class="w-full text-center md:w-1/2 bg-gray-200 h-2 rounded-full mb-4">
      <div id="progress-bar" class="bg-blue-500 h-2 rounded-full" style="width: 0%;"></div>
    </div>
    ${formData[index]}
  `;

  // Update progress bar
  const progressBar = document.getElementById('progress-bar');
  if (progressBar) {
    const progressPercentage = ((index + 1) / formData.length) * 100;
    progressBar.style.width = `${progressPercentage}%`;
  }


  // Re-attach the "Continue" button event listener
  const continueButton = document.getElementById('continue-button');
  if (continueButton) {
    continueButton.addEventListener('click', handleContinue);
  }

  // Re-attach the "Back" button event listener
  const backButton = document.getElementById('back-button');
  if (backButton) {
    backButton.addEventListener('click', handleBack);
  }

  // Re-attach the "Send OTP" button event listener for step 14
  const sendOtpButton = document.getElementById('send-otp-button');
if (sendOtpButton) {
  sendOtpButton.addEventListener('click', async () => {
    const phone = selectedValues[currentIndex]?.phone;
    const countryCode = selectedValues[currentIndex]?.countryCode || '+1';
    const fullPhoneNumber = `${countryCode}${phone}`;

    try {
      const response = await axios.post('https://api.cutmydebt.ca/send-otp', {
        mobile: fullPhoneNumber,
        otp_expiry: '5',
        template_id: '68089704d6fc0548b3420442',
      });

      console.log('OTP Sent Response:', response.data);
      // alert('OTP sent successfully!');
      handleContinue()
    } catch (error) {
      console.error('Error sending OTP:', error);
      alert('An error occurred while sending OTP.');
    }
  });
}

const verifyOtpButton = document.getElementById('verify-otp-button');
if (verifyOtpButton) {
  verifyOtpButton.addEventListener('click', async () => {
    // Combine OTP from all input boxes (if using multiple boxes)
    const otpBoxes = document.querySelectorAll('.otp-box');
    const otp = Array.from(otpBoxes).map(box => box.value).join('');
    const phone = selectedValues[13]?.phone;
    const countryCode = selectedValues[currentIndex]?.countryCode || '+1';
    const fullPhoneNumber = `${countryCode}${phone}`;

    try {
      const response = await axios.get('https://api.cutmydebt.ca/verify-otp', {
        params: {
          mobile: fullPhoneNumber,
          otp,
        },
      });

      console.log('OTP Verification Response:', response.data);
      if (response.data?.type !== "success") alert(response.data?.message);
      else
      handleContinue();
    } catch (error) {
      console.error('Error verifying OTP:', error);
      alert('An error occurred while verifying OTP.');
    }
  });
}}

function handleContinue() {
  // Validate the current step
  if (!validateStep(currentIndex)) {
    console.log('Validation failed');
    return; // Stop if validation fails
  }

  console.log({ selectedValues });

  currentIndex++;
  if (currentIndex <= formData.length) {
    renderComponent(currentIndex);
  }
  
  if (currentIndex === formData.length) {
    // Send collected data to the email API
    fetch('https://api.cutmydebt.ca/sendMail', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ selectedValues })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Redirect to thank you page with email as query param
          const email = selectedValues[13]?.email || '';
          window.location.href = `thankyou.html`;
        } else {
          alert('Failed to send details. Please try again.');
        }
      })
      .catch(error => {
        console.error('Error sending details:', error);
        alert('An error occurred while sending details.');
      });

    // document.getElementById('contact-modal').style.display = 'none';
  }
}

// Called when a car is selected
window.selectValue = function(value) {
  selectedValues[currentIndex] = value;
  console.log('Selected Car:', value);
  handleContinue();
}



// INITIALIZE
document.addEventListener('DOMContentLoaded', () => {
  renderComponent(currentIndex);

  const continueButton = document.getElementById('continue-button');
  if (continueButton) {
    continueButton.addEventListener('click', handleContinue);
  }

  const closeModal = document.getElementById('close-modal');
  if (closeModal) {
    closeModal.addEventListener('click', () => {
      document.getElementById('contact-modal').style.display = 'none';
    });
  }

  // const verifyOtpButton = document.getElementById('verify-otp-button');
  // if (verifyOtpButton) {
  //   verifyOtpButton.addEventListener('click', async () => {
  //     const otpBoxes = document.querySelectorAll('.otp-box');
  //     const otp = Array.from(otpBoxes).map(box => box.value).join(''); // Combine OTP digits
  //     const phone = selectedValues[currentIndex - 1]?.phone; // Phone is in the previous step
  //     const countryCode = selectedValues[currentIndex - 1]?.countryCode || '+1';
  //     const fullPhoneNumber = `${countryCode}${phone}`;

  //     if (!otp || otp.length !== 6) { // Assuming OTP is 6 digits
  //       alert('Please enter a valid OTP.');
  //       return;
  //     }

  //     const options = {
  //       method: 'GET',
  //       url: 'https://control.msg91.com/api/v5/otp/verify',
  //       params: {
  //         otp: otp,
  //         mobile: fullPhoneNumber,
  //       },
  //       headers: { authkey: 'YOUR_AUTH_KEY' }, // Replace with your MSG91 auth key
  //     };

  //     try {
  //       const { data } = await axios.request(options);
  //       console.log('OTP Verification Response:', data);
  //       if (data.type === 'success') {
  //         alert('OTP verified successfully!');
  //         handleContinue(); // Move to the next step
  //       } else {
  //         alert('Invalid OTP. Please try again.');
  //       }
  //     } catch (error) {
  //       console.error('Error verifying OTP:', error);
  //       alert('An error occurred while verifying OTP.');
  //     }
  //   });
  // }

  
});
const ADDRESS_API_KEY = "NT35-KY54-MG92-MP17";

function setupAddressAutocomplete() {
  const input = document.getElementById('annual-income');
  if (!input) return;

  let lastId = "";
  let suggestionBox = document.getElementById('address-suggestions');
  if (!suggestionBox) {
    suggestionBox = document.createElement('div');
    suggestionBox.id = 'address-suggestions';
    suggestionBox.style.position = 'absolute';
    suggestionBox.style.background = '#fff';
    suggestionBox.style.border = '1px solid #ccc';
    suggestionBox.style.zIndex = '1000';
    suggestionBox.style.width = '100%';
    suggestionBox.style.maxHeight = '200px';
    suggestionBox.style.overflowY = 'auto';
    suggestionBox.style.left = '0';
    suggestionBox.style.transform = 'none';
    input.parentNode.appendChild(suggestionBox);
  }

  let selectingSuggestion = false;

  input.addEventListener('input', function () {
    const searchTerm = input.value;
    console.log('Input changed:', searchTerm);
    if (!searchTerm) {
      suggestionBox.innerHTML = '';
      return;
    }

    let params = '';
    params += "&Key=" + encodeURIComponent(ADDRESS_API_KEY);
    params += "&SearchTerm=" + encodeURIComponent(searchTerm);
    params += "&LastId=" + encodeURIComponent(lastId);
    params += "&SearchFor=" + encodeURIComponent("Everything");
    params += "&Country=" + encodeURIComponent("CAN");
    params += "&LanguagePreference=" + encodeURIComponent("EN");
    params += "&MaxSuggestions=" + encodeURIComponent(5);
    params += "&MaxResults=" + encodeURIComponent(5);

    var http = new XMLHttpRequest();
    http.open('POST', 'https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3.ws', true);
    http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    http.onreadystatechange = function() {
      if(http.readyState == 4 && http.status == 200) {
        var response = JSON.parse(http.responseText);
        console.log('Response from address API:', response);
        if (response.Items.length == 1 && typeof(response.Items[0].Error) != "undefined") {
          suggestionBox.innerHTML = '<div style="padding:8px;color:red;">' + response.Items[0].Description + '</div>';
        } else if (response.Items.length == 0) {
          suggestionBox.innerHTML = '<div style="padding:8px;">No results</div>';
        } else {
          suggestionBox.innerHTML = '';
          response.Items.forEach(function(item) {
            console.log('Suggestion item:', item);
            const div = document.createElement('div');
            div.textContent = item.Text + (item.Description ? ' - ' + item.Description : '');
            div.style.padding = '8px';
            div.style.cursor = 'pointer';
            div.addEventListener('pointerdown', selectSuggestion);
            div.addEventListener('touchstart', selectSuggestion);

            function selectSuggestion(e) {
              console.log('Suggestion selected:', item);
              e.preventDefault(); // Prevents blur from firing before this
              selectingSuggestion = true;
              input.value = item?.Text + (item?.Description ? ' - ' + item?.Description : '');
              suggestionBox.innerHTML = '';
              updateIncomeValue({ target: {value:item?.Text + (item?.Description ? ' - ' + item?.Description : '')} }); // Update the selectedValues array
              lastId = item.Id;
              setTimeout(() => { selectingSuggestion = false; }, 100);
            }
            suggestionBox.appendChild(div);
          });
        }
      }
    }
    http.send(params);
  });

  // Hide suggestions when input loses focus
  input.addEventListener('blur', function() {
    setTimeout(() => {
      if (!selectingSuggestion) {
        suggestionBox.innerHTML = '';
      }
    }, 150);
  });
}

// Call this after rendering the address step
function afterRender() {
  setupAddressAutocomplete();
}

// Patch your renderComponent to call afterRender after rendering step 9
const originalRenderComponent = renderComponent;
renderComponent = function(index) {
  originalRenderComponent.call(this, index);
  if (index === 8) { // step9 is at index 8
    afterRender();
  }

  // Attach DOB input auto-slash logic for step 12 (index 11)
  if (index === 11) {
    const dobInput = document.getElementById('dob');
    if (dobInput) {
      dobInput.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 2) value = value.slice(0,2) + '/' + value.slice(2);
        if (value.length > 5) value = value.slice(0,5) + '/' + value.slice(5,9);
        e.target.value = value;
      });
    }
  }
};

